import * as angular from 'angular';

import { Roles } from '../../common';
import { ComponentDefinition, PdfExportConfiguration } from '../../models';
import { IAuthorizationService, IExportToPdfService, ILoggerService } from '../../services';

class WtStoredPdf {
    static controllerId = 'WtStoredPdf';

    files: string[];
    displayed: string[];
    configuration: PdfExportConfiguration;
    dashboardGuid: string;
    filter: string;
    hasRoles: boolean;

    static $inject = ['$scope', 'authorizationService', 'exportToPdfService', 'loggerService'];

    constructor(
        private $scope: angular.IScope,
        private authorizationService: IAuthorizationService,
        private _exportToPdfService: IExportToPdfService,
        private _loggerService: ILoggerService
    ) {}

    $onInit() {
        this.hasRoles = this.authorizationService.isInRoles([Roles.operator, Roles.master]);
        this.$scope.$watch(
            () => this.dashboardGuid,
            () => this.loadFiles()
        );
        this.$scope.$watch(
            () => this.filter,
            () => this.applyFilter()
        );
        this.loadFiles();
    }

    private loadFiles() {
        if (this.dashboardGuid) {
            this.files = [];
            this._exportToPdfService.getStorage(this.dashboardGuid).then((data) => {
                this.files = data;
                this.applyFilter();
            });
        }
    }

    private applyFilter() {
        if (this.files && this.filter) {
            const regexp = new RegExp(`.*${this.filter}.*`, 'i');
            this.displayed = this.files.filter((f) => regexp.exec(f) !== null);
        } else {
            this.displayed = this.files;
        }
    }

    export() {
        const config = angular.copy(this.configuration);
        config.isStorage = true;
        config.isPrinting = true;
        this._exportToPdfService
            .print(config)
            .then(() => this.loadFiles())
            .finally(() => (this.configuration.isPrinting = false));
    }

    download(fileName: string) {
        this._exportToPdfService.downloadStoredFile(this.dashboardGuid, fileName).catch(() => {
            this._loggerService.logError(`File ${fileName} could not be found`);
        });
    }

    ignoreClick(event: angular.IAngularEvent) {
        event.stopPropagation();
    }
}

export const wtStoredPdf: ComponentDefinition = {
    componentId: 'wtStoredPdf',
    controller: WtStoredPdf,
    template: require('./storedPdf.component.html'),
    controllerAs: 'vm',
    bindings: {
        configuration: '=',
        dashboardGuid: '='
    }
};
